<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row>
      <v-col align="center" style="padding-bottom: 0%;" cols="12">
        <v-card class="slide-card" style="max-width: 90%;">
          <div
            class="slide-content text-justify"
            style="padding: 1% !important;"
          >
            <p>
              The Center-Running BRT alternative will improve infrastructure in
              the corridor, particularly wider sidewalks. The following
              renderings provide an example of how the Center-Running BRT
              alternative could look with new dedicated transit lanes, enhanced
              stations and improved bike-ped facilities.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="image in images" :key="image" align="center" :cols="cols">
        <!-- <v-img src="../../public/static/Easel Top.png" :width="easelTop" /> -->
        <div style="cursor:pointer" @click="toggleDialog(image)">
          <v-img :src="renderImage(image)" style="width:90%" />
        </div>
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
        />
      </v-col>
    </v-row>
    <NewImagePopup
      v-if="toggled1"
      :close-modal="closeDialog"
      image="Slide7a.jpg"
    />
    <NewImagePopup
      v-if="toggled2"
      :close-modal="closeDialog"
      image="Slide7b.jpg"
    />
    <NewImagePopup
      v-if="toggled3"
      :close-modal="closeDialog"
      image="Slide8.jpg"
    />
    <NewImagePopup
      v-if="toggled4"
      :close-modal="closeDialog"
      image="Slide9.jpg"
    />
        <NewImagePopup
      v-if="toggled5"
      :close-modal="closeDialog"
      image="slide10.png"
    />
        <NewImagePopup
      v-if="toggled6"
      :close-modal="closeDialog"
      image="slide11.png"
    />
        <NewImagePopup
      v-if="toggled7"
      :close-modal="closeDialog"
      image="slide12.png"
    />
        <NewImagePopup
      v-if="toggled8"
      :close-modal="closeDialog"
      image="slide13.png"
    />
        <NewImagePopup
      v-if="toggled9"
      :close-modal="closeDialog"
      image="slide14.png"
    />
        <NewImagePopup
      v-if="toggled10"
      :close-modal="closeDialog"
      image="slide15.png"
    />
  </v-sheet>
</template>

<script>
import NewImagePopup from "@/components/NewImagePopup.vue";
// import PlayButton from "./common/PlayIcon.vue";

export default {
  name: "Tier2Alternatives",
  components: {
    NewImagePopup
    // PlayButton
  },
  data() {
    return {
      toggled1: false,
      toggled2: false,
      toggled3: false,
      toggled4: false,
      toggled5: false,
      toggled6: false,
      toggled7: false,
      toggled8: false,
      toggled9: false,
      toggled10: false,
      toggledGoals: false,
      images: ["Slide7a.jpg", "Slide7b.jpg", "Slide8.jpg", "Slide9.jpg", "slide10.png", "slide11.png", "slide12.png", "slide13.png", "slide14.png", "slide15.png"],
      image: null,
      youtubeVideo: "https://www.youtube.com/embed/-4-Z6b2BdbE"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "10%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "50%";
      }
      return "50%";
    },
    cols() {
      if (this.$vuetify.breakpoint.xs) {
        return "8";
      }
      return "4";
    }
  },
  methods: {
    renderImage(image) {
      return require(`../../public/static/slides/${image}`);
    },
    toggleDialog(image) {
      this.image = image;
      if (image.includes("7a")) {
        this.toggled1 = !this.toggled1;
      }
      if (image.includes("7b")) {
        this.toggled2 = !this.toggled2;
      }
      if (image.includes("8")) {
        this.toggled3 = !this.toggled3;
      }
      if (image.includes("9")) {
        this.toggled4 = !this.toggled4;
      }
      if (image.includes("slide10.png")) {
        this.toggled5 = !this.toggled5;
      }
      if (image.includes("11")) {
        this.toggled6 = !this.toggled6;
      }
      if (image.includes("12")) {
        this.toggled7 = !this.toggled7;
      }
      if (image.includes("13")) {
        this.toggled8 = !this.toggled8;
      }
      if (image.includes("14")) {
        this.toggled9 = !this.toggled9;
      }
      if (image.includes("15")) {
        this.toggled10 = !this.toggled10;
      }
    },
    toggleGoals() {
      this.toggledGoals = !this.toggledGoals;
    },
    closeDialog() {
      (this.toggled1 = false),
        (this.toggled2 = false),
        (this.toggled3 = false),
        (this.toggled4 = false),
        (this.toggled5 = false),
        (this.toggled6 = false),
        (this.toggled7 = false),
        (this.toggled8 = false),
        (this.toggled9 = false),
        (this.toggled10 = false),
        (this.toggledGoals = false);
    }
  }
};
</script>
